module.exports = new __parcel__URL__("button.c2e89f10.png").toString();